$(document).ready(function() {

    // PYHRN-PRIEL CARD-BUTTON
    $(".ttgPPCardButton").click(function() {

        if ($('a[href="#ttgCollapsePreise"]').hasClass('in')) {
            // Accordeon ist schon geöffnet
        } else {
            $('a[href="#ttgCollapsePreise"]').trigger('click');
        }

        $('#PYHRNPRIELCARD').animatescroll({
            padding: 200
        });
    });

    /**************************************** GOOGLE ANALYTICS **************************************/
    var analyticsIsActive;
    if ($.cookie) {
        analyticsIsActive = $.cookie("analyticsIsActive");
    }

    if ($("#googleAnalyticsDeacitvateBtn p").length && $("#googleAnalyticsAcitvateBtn p").length) {

        // check ob analytics deaktiviert ist
        if (analyticsIsActive == "false") {

            $("#googleAnalyticsDeacitvateBtn p").addClass('inActiveButton');
            $("#googleAnalyticsAcitvateBtn p").addClass('activeButton');

            $("#googleAnalyticsDeacitvateBtn p").click(function(event) {
                return false;
            });

            $("#googleAnalyticsAcitvateBtn p").click(function() {
                $("#googleAnalyticsAcitvateBtn p").removeClass('activeButton').addClass('inActiveButton');
                $("#googleAnalyticsDeacitvateBtn p").removeClass('inActiveButton').addClass('activeButton');
                $.cookie('analyticsIsActive', 'true', {
                    expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365),
                    path: '/'
                });
            });

        } else {

            $("#googleAnalyticsDeacitvateBtn p").addClass('activeButton');
            $("#googleAnalyticsAcitvateBtn p").addClass('inActiveButton');

            $("#googleAnalyticsAcitvateBtn p").click(function(event) {
                return false;
            });

            $("#googleAnalyticsDeacitvateBtn p").click(function() {
                $("#googleAnalyticsDeacitvateBtn p").removeClass('activeButton').addClass('inActiveButton');
                $("#googleAnalyticsAcitvateBtn p").removeClass('inActiveButton').addClass('activeButton');
                $.cookie('analyticsIsActive', 'false', {
                    expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365),
                    path: '/'
                });
            });

        }

    }

    if (analyticsIsActive == "false") {
        window['ga-disable-UA-11392972-1'] = true;
    }

});


function isValidEmailAddress(emailAddress) {
    //console.log("function");
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
}